import { useState } from "react";
import {
  Backdrop,
  SpeedDialAction,
  SpeedDialIcon,
  SpeedDial as MuiSpeedDial,
  SpeedDialProps as MuiSpeedDialProps,
  CircularProgress,
} from "@mui/material";

import useBoundStore from "store";
import styles from "./speedDial.module.scss";

export interface SpeedDialProps extends MuiSpeedDialProps {
  icon?: JSX.Element;
  openIcon?: JSX.Element;
  actions: Array<{
    icon: JSX.Element;
    name: string;
    action: () => Promise<void> | void;
  }>;
}

function SpeedDial(props: SpeedDialProps) {
  const { icon, openIcon, actions, ...rest } = props;
  const [open, setOpen] = useState(false);
  const [loadingAction, setLoadingAction] = useState<null | number>(null);
  const isMobileDevice = useBoundStore((state) => state.miscellaneous.isMobileDevice);

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
  };

  const handleAction = async (action: () => Promise<void> | void, index: number) => {
    setLoadingAction(index);

    await action();

    setOpen(false);
    setLoadingAction(null);
  };

  return (
    <>
      <Backdrop open={open} />
      <MuiSpeedDial
        sx={{ position: isMobileDevice ? "fixed" : "absolute", bottom: "1rem", right: "1rem" }}
        className={styles.speedDial}
        icon={<SpeedDialIcon icon={icon} openIcon={openIcon} />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        {...rest}
      >
        {actions.map((action, index) => (
          <SpeedDialAction
            key={action.name}
            icon={loadingAction === index ? <CircularProgress size={24} /> : action.icon}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={() => handleAction(action.action, index)}
          />
        ))}
      </MuiSpeedDial>
    </>
  );
}

export default SpeedDial;
